/**
 * 前端枚举 / 兜底值的展示文案。契约值（环节号、包牌状态、批次状态、合并出来的客户名）保持原样参与筛选，
 * 只在展示时经这里翻译；后端返回的业务数据（客户名、运单状态、异常原因、账号）不经过这里。
 */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BAG_RESULT_KEY, BATCH_STATUS_KEY, OTHER_CUSTOMER, UNKNOWN_CUSTOMER, type BatchStatus } from '../constants';
import type { BagResult } from '../types';
import type { TreeLabels } from './tree';

export const I18N = 'wms.delivery.bagStayMonitor';

export interface Labels {
    /** 环节标题；5 = 错分未重装（只在明细里出现） */
    stageTitle: (s: number) => string;
    impact: (s: number) => string;
    action: (s: number) => string;
    customer: (c: string) => string;
    bagResult: (r: BagResult) => string;
    batchStatus: (s: BatchStatus) => string;
    tree: TreeLabels;
}

export function useLabels(): Labels {
    const { t } = useTranslation();
    return useMemo(() => {
        const s = (k: string) => t(`${I18N}.${k}`) ?? '';
        return {
            stageTitle: (n: number) => s(`stages.s${n}`),
            impact: (n: number) => s(`impact.s${n}`),
            action: (n: number) => s(`action.s${n}`),
            customer: (c: string) =>
                c === OTHER_CUSTOMER ? s('customers.other') : c === UNKNOWN_CUSTOMER ? s('customers.unknown') : c,
            bagResult: (r: BagResult) => s(`bagResult.${BAG_RESULT_KEY[r]}`),
            batchStatus: (b: BatchStatus) => s(`batchStatus.${BATCH_STATUS_KEY[b]}`),
            tree: {
                unbatched: s('tree.unbatched'),
                noLetter: s('tree.noLetter'),
                unknownFlow: s('tree.unknownFlow'),
                noWarehouse: s('tree.noWarehouse')
            }
        };
    }, [t]);
}

